import { render, staticRenderFns } from "./astanamap.vue?vue&type=template&id=34cdd662&"
import script from "./astanamap.vue?vue&type=script&lang=ts&"
export * from "./astanamap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports